<template>
	<div>
		<app-header></app-header>

		<div class="app flex-row align-items-center" style="position:relative; top:60px">
			<div class="container">
				<b-row class="justify-content-center">
					<b-col md="8" sm="8">
						<b-card no-body class="mx-4">
							<b-card-header class="p-4">
								<h4>Inscription au portail Fournisseur de Orange Burkina</h4>
							</b-card-header>
							<b-card-body class="p-4">
								<b-card-title class="text-center">Avertissement</b-card-title>
								<b-card-sub-title class="mb-2 text-justify">
									L'inscription sur le portail fornisseur ne vaut pas enregistrement dans la base fournisseurs. Votre
									demande d'agrément sera examinée et l'accord ou le refus de l'agrément vous sera notifié
									ultérieurement par mail.
								</b-card-sub-title>
								<el-form size="mini" :model="rfournisseur" ref="registerForm" :rules="fields">
									<br /><br />
									<h3>Informations Générales sur l'entreprise</h3>
									<!-- <p class="text-muted">Create your account</p> -->
									<br />
									<el-alert :title="uniqueMessage" type="error" v-if="!uniqueOK" :closable="false"> </el-alert><br />
									<b-form-group v-loading="checkingUnique">
										<el-form-item label="" prop="pays_id">
											<el-select
												ref="pays"
												:filterable="true"
												v-model="rfournisseur.pays_id"
												placeholder="Pays"
												@change="chooseCtry($event)"
												@blur="onCheckUnique()"
											>
												<el-option
													v-for="pay of pays"
													:key="pay.sync_id"
													:label="pay.libelle"
													:id="pay.sync_id"
													:value="pay.sync_id"
												></el-option>
											</el-select>
										</el-form-item>

										<el-form-item prop="id_fournisseur_1">
											<el-input
												ref="id_frn_1"
												v-model="rfournisseur.id_fournisseur_1"
												placeholder="N° IFU"
												@blur="onCheckUnique()"
											></el-input>
										</el-form-item>

										<el-form-item labelPosition="left" prop="nom_commercial">
											<el-input
												ref="nom_com"
												v-model="rfournisseur.nom_commercial"
												placeholder="Nom Commercial"
												@blur="onCheckUnique()"
											></el-input>
										</el-form-item>
									</b-form-group>
								</el-form>

								<hr />

								<h3>Creation des Identifiants</h3>
								<el-form></el-form>
								<b-input-group class="mb-3">
									<b-input-group-prepend>
										<b-input-group-text><i class="icon-role"></i></b-input-group-text>
									</b-input-group-prepend>

									<b-form-input
										type="text"
										v-model="user.titre"
										class="form-control"
										placeholder="Titre de l'utilisateur responsable"
									/>
								</b-input-group>

								<b-input-group class="mb-3">
									<b-input-group-prepend>
										<b-input-group-text><i class="icon-user"></i></b-input-group-text>
									</b-input-group-prepend>

									<b-form-input type="text" v-model="user.nom" class="form-control" placeholder="Nom" />
								</b-input-group>

								<b-input-group class="mb-3">
									<b-input-group-prepend>
										<b-input-group-text><i class="icon-user"></i></b-input-group-text>
									</b-input-group-prepend>
									<b-form-input v-model="user.prenom" type="text" class="form-control" placeholder="Prenom" />
								</b-input-group>

								<el-alert :title="uniqueMailMessage" type="error" v-if="!uniqueMailOK" :closable="false" />
								<b-input-group class="mb-3" v-loading="checkingMailUnique">
									<b-input-group-prepend>
										<b-input-group-text>@</b-input-group-text>
									</b-input-group-prepend>
									<input
										v-model="user.email"
										type="email"
										required
										class="form-control"
										placeholder="Email"
										@blur="onCheckMailUnique()"
									/>
									<!-- <b-form-input v-model="user.email" type="email" required class="form-control" placeholder="Email" @change="onCheckMailUnique()" autocomplete="email" /> -->
								</b-input-group>

								<el-alert
									:title="passConfirmMessage"
									type="error"
									v-if="user.password_confirmation && user.password != user.password_confirmation"
									:closable="false"
								/>
								<b-input-group class="mb-3">
									<b-input-group-prepend>
										<b-input-group-text><i class="icon-lock"></i></b-input-group-text>
									</b-input-group-prepend>
									<b-form-input
										v-model="user.password"
										type="password"
										class="form-control"
										placeholder="Mot de passe"
									/>
								</b-input-group>

								<b-input-group class="mb-4">
									<b-input-group-prepend>
										<b-input-group-text><i class="icon-lock"></i></b-input-group-text>
									</b-input-group-prepend>
									<b-form-input
										v-model="user.password_confirmation"
										type="password"
										class="form-control"
										placeholder="Repeter mot de passe"
									/>
								</b-input-group>

								<b-button
									v-if="
										uniqueOK &&
											uniqueMailOK &&
											user.password_confirmation &&
											user.password == user.password_confirmation
									"
									v-loading="registering"
									variant="primary"
									block
									@click="onRegister({ rfournisseur, user })"
									>S'inscrire</b-button
								>
							</b-card-body>
							<b-card-footer class="p-4"> </b-card-footer>
						</b-card>
					</b-col>
				</b-row>
			</div>
		</div>

		<el-dialog title="" :visible.sync="endregister" :close-on-click-modal="true">
			<div style="" class="container" align="center">
				<el-card class="box-card" align="center">
					<el-alert title="" style="font-weight:20px" :type="message.type" show-icon>
						<span style="font-size:19px">
							{{ message.texte }}
						</span>
					</el-alert>
					<br />
					<el-button type="primary" @click="$router.push('/pages/home')">Revenir à l'accueil</el-button>
					<el-button type="primary" @click="$router.push('/pages/login')">Connectez Vous</el-button>
				</el-card>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import AppHeader from "../../containers/AppHeader";

export default {
	name: "Register",
	components: {
		AppHeader
	},
	data() {
		return {
			user: {
				nom: "",
				prenom: "",
				email: "",
				titre: "",
				password: "",
				password_confirmation: ""
			},

			rfournisseur: {
				pays_id: "",
				id_fournisseur_1: "",
				nom_commercial: ""
			},
			check_unique: false,
			country: "",
			passConfirmMessage: "Les mots de passes ne correspondent pas.",
			passNotConfirmed: false,
			registering: false,
			message: {
				type: "",
				texte: ""
			},
			endregister: false
		};
	},
	computed: {
		...mapState({
			fournisseur: state => state.fournisseur,
			fields: state => state.fields,
			pays: state => state.pays,
			activites: state => state.activites,
			uniqueOK: state => state.auth.uniqueOK,
			uniqueMailOK: state => state.auth.uniqueMailOK,
			checkingUnique: state => state.auth.checkingUnique,
			checkingMailUnique: state => state.auth.checkingMailUnique
		}),

		uniqueMessage() {
			return `L'entreprise ${this.rfournisseur.nom_commercial} identifiée par ${this.rfournisseur.id_fournisseur_1} existe déjà en ${this.country}`;
		},
		uniqueMailMessage() {
			return `Cet email est déjà utilisé`;
		}
	},
	methods: {
		...mapActions(["register", "checkUnique", "checkMailUnique"]),
		checkUnique() {
			return false;
		},
		onRegister(data) {
			this.registering = true;
			this.register(data)
				.then(resp => {
					this.registering = false;
					this.endregister = true;
					console.log("register", resp);
					this.message.type = "success";
					this.message.texte =
						"Un lien de confirmation vous a été envoyé par mail, cliquez sur le lien pour confirmer votre adresse et vous connecter";
				})
				.catch(err => {
					this.registering = false;
					this.endregister = true;
					console.log("regErr", err), (this.message.type = "error");
					this.message.texte = "Une erreur est survenu, veuillez reessayer";
				});
		},

		chooseCtry(ctr) {
			console.log(document.getElementById(ctr).querySelector("span").innerHTML);
			this.country = document.getElementById(ctr).querySelector("span").innerHTML;
		},
		onCheckUnique() {
			console.log("checkunique");
			let id_frn_1 = this.$refs["id_frn_1"].value;
			let nom_com = this.$refs["nom_com"].value;
			let pays = this.$refs["pays"].value;

			if (id_frn_1 && nom_com && pays) {
				this.$store.dispatch("checkUnique", this.rfournisseur);
				console.log({
					id_frn_1,
					nom_com,
					pays
				});
			}
		},

		onCheckMailUnique() {
			console.log("checkmailUnique");
			if (this.user.email != "") this.$store.dispatch("checkMailUnique", this.user.email);
		}
	},
	watch: {},
	mounted() {
		console.log("uniqueOK ?", this.uniqueOK);
		this.endregister = false;
	}
};
</script>

<style scoped>
.menu-item {
	padding-right: 20px;
}
</style>
